import React, { createContext, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

export const KanbanContext = createContext(null);

export const KanbanProvider = ({ children, commonProps }) => {

  const kanbanRef = useRef(null); 

  const [kanbanData, setKanbanData] = useState(null);
  const [columnWidth, setColumnWidth] = useState(300);
  const [filter, setFilter] = useState([]);

  const [currentWorkspaceUuid, setCurrentWorkspaceUuid] = useState(null);

  const heartbeatUpdateData = useSelector((state: any) => state.heartbeatUpdateData);

    
  return (
    <KanbanContext.Provider
      value={{
        kanbanRef,
        kanbanData,
        setKanbanData,
        columnWidth,
        setColumnWidth,
        filter,
        setFilter,
        currentWorkspaceUuid,
        setCurrentWorkspaceUuid,
        heartbeatUpdateData,
        ...commonProps
      }}
    >
      {children}
    </KanbanContext.Provider>
  );
};

KanbanProvider.propTypes = {
  children: PropTypes.node.isRequired,
  commonProps: PropTypes.object
};
